import { guideSites, isSiteIcon, type Guide, type GuideSite } from '@nolens/domain';
import { cx } from './cx';
import { useLocale } from './locale';
import { uiText } from './ui-text';

/** Ícone de um site (o guardado ao gravar) ou a inicial do nome, num quadrado. */
export function SiteIcon({
  site,
  className,
}: {
  site: Pick<GuideSite, 'name' | 'icon'>;
  className?: string;
}) {
  if (site.icon && isSiteIcon(site.icon))
    return (
      <img
        src={site.icon}
        alt=""
        className={cx('size-4 shrink-0 rounded-[3px] object-contain', className)}
      />
    );
  return (
    <span
      aria-hidden="true"
      className={cx(
        'inline-flex size-4 shrink-0 items-center justify-center rounded-[4px] bg-accent-soft text-[10px] font-bold text-accent-text',
        className,
      )}
    >
      {site.name.charAt(0).toUpperCase()}
    </span>
  );
}

/** «<ícone> Nome» de cada site usado no guia. */
export function SiteChips({
  guide,
  className,
}: {
  guide: Pick<Guide, 'steps'>;
  className?: string;
}) {
  const t = uiText(useLocale());
  const sites = guideSites(guide);
  if (!sites.length) return null;
  return (
    <ul className={cx('flex flex-wrap gap-1.5', className)} aria-label={t.appsUsed}>
      {sites.map((s) => (
        <li
          key={s.host}
          title={s.host}
          className="inline-flex items-center gap-2 rounded-[8px] bg-surface-1 py-1 pl-2 pr-3 text-[13px] font-medium shadow-[inset_0_0_0_1px_var(--border)]"
          data-site={s.host}
        >
          <SiteIcon site={s} />
          {s.name}
        </li>
      ))}
    </ul>
  );
}
